import { getNotificationConfig } from '@/lib/sanity';

// Default fallback values
export const defaultNotificationConfig = {
  showNotificationBar: true,
  notificationText: "Join our Newsletter!",
  notificationCTA: {
    text: "",
    href: "/newsletter",
  }
};

// Function to get notification config from Sanity
export async function getNotificationConfigFromSanity() {
  try {
    return await getNotificationConfig();
  } catch (error) {
    console.error('Failed to fetch notification config from Sanity:', error);
    return defaultNotificationConfig;
  }
}

// Export default values for backward compatibility
export const showNotificationBar = defaultNotificationConfig.showNotificationBar;
export const notificationText = defaultNotificationConfig.notificationText;
export const notificationCTA = defaultNotificationConfig.notificationCTA; 